import { generateStripeState } from "@/services/vuex.service";
import axios from "@/plugins/axios";
import { AxiosResponse } from "axios";
import { ActionContext } from "vuex";

const options = {
  api: {
    list: () => `/api/stripe/paymentIntent`,
    update: ({ id }: { id: string }) => `/api/stripe/paymentIntent/${id}`,
    delete: ({ id }: { id: string }) => `/api/stripe/paymentIntent/${id}`,
    create: () => `/api/stripe/paymentIntent`,
    get: ({ id }: { id: string }) => `/api/stripe/paymentIntent/${id}`,
  },
  state: {
    collectionName: "paymentIntent",
  },
  getters: {
    getPagination: "getPaymentIntentPagination",
    getCollection: "getPaymentIntents",
    getLoading: "getPaymentIntentsLoading",
    getListLoading: "getListPaymentIntentsLoading",
    getCreateLoading: "getCreatePaymentIntentsLoading",
    getUpdateLoading: "getUpdatePaymentIntentsLoading",
    getDeleteLoading: "getDeletePaymentIntentsLoading",
  },
  actions: {
    list: "listPaymentIntents",
    update: "updatePaymentIntent",
    create: "createPaymentIntent",
    get: "getPaymentIntent",
    delete: "deletePaymentIntent",
  },
  mutationKey: "PAYMENT_INTENT",
};

const {
  state: stripeState,
  getters: stripeGetters,
  actions: stripeActions,
  mutations: stripeMutations,
} = generateStripeState(options);

export default {
  namespaced: true,
  state: (): any => ({
    ...stripeState,
  }),
  getters: {
    ...stripeGetters,
  },
  mutations: {
    ...stripeMutations,
  },
  actions: {
    ...stripeActions,
    confirmPaymentIntent(
      context: ActionContext<any, any>,
      // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
      data: any
    ): Promise<any> {
      context.commit("PAYMENT_INTENT_UPDATE_LOADING", true);

      return axios
        .post(`/api/stripe/paymentIntent/${data.id}/confirm`, data)
        .then((res) => {
          context.commit("PAYMENT_INTENT_UPDATE", res.data);
          return res;
        })
        .catch((e: AxiosResponse) => {
          context.commit(
            "snackbar/toastError",
            { message: e.data },
            { root: true }
          );
          return e;
        })
        .finally(() => {
          context.commit("PAYMENT_INTENT_UPDATE_LOADING", false);
        });
    },
    capture(
      context: ActionContext<any, any>,
      // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
      data: any
    ): Promise<any> {
      context.commit("PAYMENT_INTENT_UPDATE_LOADING", true);

      return axios
        .post(`/api/stripe/paymentIntent/${data.id}/capture`, data)
        .then((res) => {
          context.commit("PAYMENT_INTENT_UPDATE", res.data);
          return res;
        })
        .catch((e: AxiosResponse) => {
          console.log(e);
          context.commit(
            "snackbar/toastError",
            { message: e.data },
            { root: true }
          );
          return e;
        })
        .finally(() => {
          context.commit("PAYMENT_INTENT_UPDATE_LOADING", false);
        });
    },
    cancel(
      context: ActionContext<any, any>,
      // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
      data: any
    ): Promise<any> {
      context.commit("PAYMENT_INTENT_UPDATE_LOADING", true);

      return axios
        .post(`/api/stripe/paymentIntent/${data.id}/cancel`, data.reason)
        .then((res) => {
          context.commit("PAYMENT_INTENT_UPDATE", res.data);
          return res;
        })
        .catch((e: AxiosResponse) => {
          console.log(e);
          context.commit(
            "snackbar/toastError",
            { message: e.data },
            { root: true }
          );
          return e;
        })
        .finally(() => {
          context.commit("PAYMENT_INTENT_UPDATE_LOADING", false);
        });
    },
  },
};
